export const CORE_WINDOW_IDS = {
    PROPERTIES: "properties",
    SETTINGS: "settings",
    OBJECT_TREE: "objectTree",
    DIMENSION: "dimension",
} as const;

export type CoreWindowId = (typeof CORE_WINDOW_IDS)[keyof typeof CORE_WINDOW_IDS];
